{
	const streamerContent = document.querySelector('.streamer__content');
	if (streamerContent) {

		const wrapperContent = document.querySelector('.streamer__wrapper');
		const streamContentChildren = streamerContent.querySelectorAll('.streamer__message');

		for (let i = 0; i < 20; i++) {
			streamContentChildren.forEach(function (el) {
				const clonnedEl = el.cloneNode(true);
				streamerContent.appendChild(clonnedEl);
			})
		}
	}

}